import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '@/apiConnection/ApiService';
import { Urls } from '@/apiConnection/urls';
import { Utils } from '@/utils/utils';
import { CustomSelectComponent } from '@/components/custom-select/custom-select.component';
@Component({
  imports: [ReactiveFormsModule, FormsModule, CustomSelectComponent],
  templateUrl: './document-accept-budget.page.html'
})
export class DocumentAcceptBudgetPage implements OnInit {
  budgetControl = new FormControl(null);
  date = new Date().toISOString().split('T')[0];
  budgets: any[] = [];
  loading = false;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.loadBudgets();
  }

  loadBudgets() {
    const config = { documents: { type: 'presupuesto', exclude_drafts: true } };
    this.apiService.getSelectors(Urls.urls.selectors, config).subscribe({
      next: (data: any) => {
        this.budgets = (data.documents || []).map((doc: any) => {
          const d = new Date(doc.date);
          const dateStr = d.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
          return {
            value: doc.id,
            label: doc.id_by_company + '/' + doc.year,
            subLabel: dateStr,
            extra: doc.total != null ? (doc.total / 100).toFixed(2) : undefined,
          };
        });
        this.cdr.detectChanges();
      }
    });
  }

  accept(type: 'factura' | 'albaran' | 'devolucion') {
    const budgetId = this.budgetControl.value;
    if (!budgetId) {
      Utils.notification.alert('Selecciona un presupuesto');
      return;
    }

    this.loading = true;

    this.apiService.getById(Urls.urls.documents, budgetId).subscribe({
      next: (response: any) => {
        const doc = response.document;
        const newPayload: any = {
          ...doc,
          type,
          date: this.date,
          reference: doc.id,
        };
        const invoice_split = Array.isArray(doc.invoice_split) ? doc.invoice_split : [];
        newPayload.id = undefined;
        newPayload.invoice_split = invoice_split.length ? invoice_split : null,
        newPayload.items = (doc.products || []).map((item: any) => ({
          ...item,
          product_id: item.pivot.product_id,
          quantity: item.pivot.quantity,
          discount: item.pivot.discount,
          price: item.pivot.price, 
          tax: item.pivot.tax,
          id: null,
        }));

        this.apiService.save(Urls.urls.documents, newPayload, 0).subscribe({
          next: (result: any) => {
            const labels: Record<string, string> = { factura: 'Factura', albaran: 'Albarán', devolucion: 'Devolución' };
            Utils.notification.success((labels[type] || type) + ' creado correctamente desde presupuesto');
            this.router.navigate(['/invoice/view/' + result.document.id]);
          },
          error: (error: any) => {
            this.loading = false;
            Utils.notification.alert(Utils.extractErrorMessage(error) || 'Error al crear ' + type);
            this.cdr.detectChanges();
          },
          complete: () => {
            this.loading = false;
          }
        });
      },
      error: (error: any) => {
        this.loading = false;
        Utils.notification.alert(Utils.extractErrorMessage(error) || 'Error al cargar el presupuesto');
        this.cdr.detectChanges();
      }
    });
  }
}
